import { FBDate } from "./Globals";


export enum InvestmentKnowledgeOption {
    ListedStocks = "ListedStocks",
    Bonds = "Bonds",
    InvestmentAssociations = "InvestmentAssociations",
    CrowdfundingCrowdlending = "CrowdfundingCrowdlending",
    Other = "Other"
}

export const InvestmentKnowledgeOptionList = [InvestmentKnowledgeOption.ListedStocks, InvestmentKnowledgeOption.Bonds,
InvestmentKnowledgeOption.InvestmentAssociations, InvestmentKnowledgeOption.CrowdfundingCrowdlending, InvestmentKnowledgeOption.Other]

export enum InvestmentExperienceEducationalLevelOption {
    ElementarySchool = "ElementarySchool",
    TenthGrade = "TenthGrade",
    ShortHigherEducation = "ShortHigherEducation",
    MediumHigherTermEducation = "MediumHigherTermEducation",
    LongHigherTermEducation = "LongHigherTermEducation",
    Phd = "Phd"
}

export const InvestmentExperienceEducationalLevelOptionList = [
    InvestmentExperienceEducationalLevelOption.ElementarySchool,
    InvestmentExperienceEducationalLevelOption.TenthGrade,
    InvestmentExperienceEducationalLevelOption.ShortHigherEducation,
    InvestmentExperienceEducationalLevelOption.MediumHigherTermEducation,
    InvestmentExperienceEducationalLevelOption.LongHigherTermEducation,
    InvestmentExperienceEducationalLevelOption.Phd
]


export type InvestmentExperience = {
    option: InvestmentKnowledgeOption;
    amount: number;
    quantity: number;
}

type InvestmentPurpose = {
    purpose: string;
    duration: string;
    profile: string;
    substainable: string;
}

type RiskProfileIncome = {
    salary: number;
    interestIncome: number;
    dividendIncome: number;
    realEstateIncome: number;
}

type RiskProfileAssets = {
    pensionAssets: number;
    stockAssets: number;
    bondAssets: number;
}

export type RiskProfileExpenses = {
    childSupport: number;
    mortgage: number;
    otherLoans: number;
    insurances: number;
    utilities: number;
    subscriptionServices: number;
    incometaxAndPropertyTax: number;
}

export type RiskProfile = {
    riskProfileIncome: RiskProfileIncome;
    riskProfileAssets: RiskProfileAssets;
}

export type KnowledgeTest = {
    investmentExperiences: InvestmentExperience[];
    educationalLevel: InvestmentExperienceEducationalLevelOption;
    investmentPurpose: InvestmentPurpose;
    riskProfile: RiskProfile;
    riskProfileExpenses: RiskProfileExpenses;
    completedDate: FBDate;
}


export type RiskProfileCalculation = {
    income: number, assets: number, expenses: number,
    netWorth: number, lossAbility: number,
    newWorthMinTreshold: boolean,
    lossAbilityMinTreshold: boolean,
    stocksMinExperience: boolean,
    crowdinvestmentMinExperience: boolean,
    educationalLevelThreshold: boolean,
}

export const calculateInvestorRiskProfile = (riskProfile: RiskProfile, riskProfileExpenses: RiskProfileExpenses, investmentExperiences?: InvestmentExperience[], educationalLevel?: InvestmentExperienceEducationalLevelOption): RiskProfileCalculation => {
    const { dividendIncome, salary, interestIncome, realEstateIncome } = riskProfile.riskProfileIncome
    const { pensionAssets, stockAssets, bondAssets } = riskProfile.riskProfileAssets
    const { childSupport, mortgage, otherLoans, insurances, utilities, subscriptionServices, incometaxAndPropertyTax } = riskProfileExpenses
    const income = dividendIncome + salary + interestIncome + realEstateIncome
    const assets = pensionAssets + stockAssets + bondAssets
    const expenses = childSupport + mortgage + otherLoans + insurances + utilities + subscriptionServices + incometaxAndPropertyTax

    const netWorth = income + assets - expenses
    const lossAbility = netWorth * 0.10

    const newWorthMinTreshold = netWorth >= 100000
    const lossAbilityMinTreshold = netWorth >= 10000
    const stocksMinExperience = (investmentExperiences || []).filter((item) => item.option === InvestmentKnowledgeOption.CrowdfundingCrowdlending).length >= 20
    const crowdinvestmentMinExperience = (investmentExperiences || []).filter((item) => item.option === InvestmentKnowledgeOption.CrowdfundingCrowdlending).length >= 5
    const educationalLevelThreshold = educationalLevel !== InvestmentExperienceEducationalLevelOption.ElementarySchool 

    return { netWorth, income, assets, expenses, lossAbility, newWorthMinTreshold, lossAbilityMinTreshold, stocksMinExperience, crowdinvestmentMinExperience, educationalLevelThreshold }
}
